/**
 * @class CustomElement
 * @extends {HTMLElement}
 * @description Example custom element for the project.
 */
export class CustomElement extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.innerHTML = '<div>Custom Element</div>';
  }
}

customElements.define('custom-element', CustomElement); 